import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { safeValue, hasValue, isChecked, saveReceptionData } from "./util";

function ReceptionForm({ master, subproduct }) {
  const { register, handleSubmit, watch, setValue } = useForm({
    defaultValues: {
      // Documentos a entregar
      master_awb: safeValue(master?.preve_save?.master_awb, "1"),
      master_eawb: master?.preve_save?.master_awb_e ? "1" : "0",
      house_manifest: safeValue(master?.preve_save?.house_manifest, "1"),
      simplified_request: safeValue(
        master?.preve_save?.simplified_request,
        "1"
      ),
      cargo_transfer: safeValue(master?.preve_save?.cargo_transfer, "1"),
      security_letter: safeValue(master?.preve_save?.security_letter, "1"),
      acceptance_letter: safeValue(master?.preve_save?.acceptance_letter, "1"),
      custom_badge: safeValue(master?.preve_save?.custom_badge, "1"),

      // Naturaleza
      nat_cgo: master?.preve_save?.nat_cgo,
      nat_cgo_pieces: master?.preve_save?.nat_cgo_pieces || "",
      nat_cgo_weight: master?.preve_save?.nat_cgo_weight || "",
      nat_dgr: master?.preve_save?.nat_dgr,
      nat_dgr_pieces: master?.preve_save?.nat_dgr_pieces || "",
      nat_dgr_weight: master?.preve_save?.nat_dgr_weight || "",
      nat_per: master?.preve_save?.nat_per,
      nat_per_pieces: master?.preve_save?.nat_per_pieces || "",
      nat_per_weight: master?.preve_save?.nat_per_weight || "",
      nat_avi: master?.preve_save?.nat_avi,
      nat_avi_pieces: master?.preve_save?.nat_avi_pieces || "",
      nat_avi_weight: master?.preve_save?.nat_avi_weight || "",
      nat_val: master?.preve_save?.nat_val,
      nat_val_pieces: master?.preve_save?.nat_val_pieces || "",
      nat_val_weight: master?.preve_save?.nat_val_weight || "",
      nat_hum: master?.preve_save?.nat_hum,
      nat_hum_pieces: master?.preve_save?.nat_hum_pieces || "",
      nat_hum_weight: master?.preve_save?.nat_hum_weight || "",
      nat_dip: master?.preve_save?.nat_dip,
      nat_dip_pieces: master?.preve_save?.nat_dip_pieces || "",
      nat_dip_weight: master?.preve_save?.nat_dip_weight || "",
      nat_nwp: master?.preve_save?.nat_nwp,
      nat_nwp_pieces: master?.preve_save?.nat_nwp_pieces || "",
      nat_nwp_weight: master?.preve_save?.nat_nwp_weight || "",
      nat_mal: master?.preve_save?.nat_mal,
      nat_mal_pieces: master?.preve_save?.nat_mal_pieces || "",
      nat_mal_weight: master?.preve_save?.nat_mal_weight || "",
      nat_com: master?.preve_save?.nat_com,
      nat_com_pieces: master?.preve_save?.nat_com_pieces || "",
      nat_com_weight: master?.preve_save?.nat_com_weight || "",
      nat_vic: master?.preve_save?.nat_vic,
      nat_vic_pieces: master?.preve_save?.nat_vic_pieces || "",
      nat_vic_weight: master?.preve_save?.nat_vic_weight || "",
      nat_pil: master?.preve_save?.nat_pil,
      nat_pil_pieces: master?.preve_save?.nat_pil_pieces || "",
      nat_pil_weight: master?.preve_save?.nat_pil_weight || "",

      // Manejo
      han_ice: master?.preve_save?.han_ice,
      han_ice_pieces: master?.preve_save?.han_ice_pieces || "",
      han_ice_weight: master?.preve_save?.han_ice_weight || "",
      han_wet: master?.preve_save?.han_wet,
      han_wet_pieces: master?.preve_save?.han_wet_pieces || "",
      han_wet_weight: master?.preve_save?.han_wet_weight || "",
      han_big: master?.preve_save?.han_big,
      han_big_pieces: master?.preve_save?.han_big_pieces || "",
      han_big_weight: master?.preve_save?.han_big_weight || "",
      han_hea: master?.preve_save?.han_hea,
      han_hea_pieces: master?.preve_save?.han_hea_pieces || "",
      han_hea_weight: master?.preve_save?.han_hea_weight || "",
      han_hwc: master?.preve_save?.han_hwc,
      han_hwc_pieces: master?.preve_save?.han_hwc_pieces || "",
      han_hwc_weight: master?.preve_save?.han_hwc_weight || "",
      han_col: master?.preve_save?.han_col,
      han_col_pieces: master?.preve_save?.han_col_pieces || "",
      han_col_weight: master?.preve_save?.han_col_weight || "",
      han_fro: master?.preve_save?.han_fro,
      han_fro_pieces: master?.preve_save?.han_fro_pieces || "",
      han_fro_weight: master?.preve_save?.han_fro_weight || "",
      han_na: master?.preve_save?.han_na,
      han_na_pieces: master?.preve_save?.han_na_pieces || "",
      han_na_weight: master?.preve_save?.han_na_weight || "",

      // Contenedores activos
      contActivos_RKN: master?.preve_save?.contActivos_RKN || false,
      contActivos_RAP: master?.preve_save?.contActivos_RAP || false,
      prepContenedor_RKN: master?.preve_save?.prepContenedor_RKN || false,
      prepContenedor_RAP: master?.preve_save?.prepContenedor_RAP || false,
      contActivos_RKN_number: master?.preve_save?.contActivos_RKN_number || "",
      contActivos_RAP_number: master?.preve_save?.contActivos_RAP_number || "",
      prepContenedor_RKN_number:
        master?.preve_save?.prepContenedor_RKN_number || "",
      prepContenedor_RAP_number:
        master?.preve_save?.prepContenedor_RAP_number || "",

      // Entregas adicionales
      specialLoads: master?.preve_save?.special_cargo,
      interlineLoads: master?.preve_save?.interlineal_cargo,
      ata_sat_office: master?.preve_save?.ata_sat_office || "",
      intcar_transfer: master?.preve_save?.intcar_transfer || "",
      perishables_certified: master?.preve_save?.perishables_certified || "",
      dg: master?.preve_save?.dg || "",
      shipper_certified: master?.preve_save?.shipper_certified || "",
      hr_cert: master?.preve_save?.hr_cert || "",
      hr_permission_transfer: master?.preve_save?.hr_permission_transfer || "",
      hr_permission: master?.preve_save?.hr_permission || "",

      // DG
      has_dg_exempt: master?.preve_save?.has_dg_exempt || "",
      un_dg: master?.preve_save?.un_dg || "",

      // Temperatura
      required_temp: "N/A", // Valor por defecto
    },
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async (formData) => {
    setIsSubmitting(true);
    console.log("===========formData=========================");
    console.log(formData);
    console.log("====================================");
    // try {
    //   const userData = localStorage.getItem("user");
    //   const user = userData ? JSON.parse(userData) : null;

    //   await saveReceptionData(formData, master, subproduct, user);
    // } catch (error) {
    //   console.error("Error in onSubmit:", error);
    // } finally {
    //   setIsSubmitting(false);
    // }
  };

  const handleTicket = () => {
    alert("Ticket");
  };

  // Si no hay datos, mostrar mensaje
  if (!master) {
    return (
      <div className="container-fluid">
        <div className="alert alert-info text-center">
          Cargando datos del formulario...
        </div>
      </div>
    );
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-3">
              <p>
                <span className="fw-bold">Master:</span>{" "}
                {safeValue(master?.resp?.awb, "N/A")}
              </p>
            </div>
            <div className="col-3">
              <p>
                <span className="fw-bold">Origen:</span>{" "}
                {safeValue(master?.resp?.master_orig)}
              </p>
            </div>
            <div className="col-3">
              <p>
                <span className="fw-bold">Destino:</span>{" "}
                {safeValue(master?.resp?.master_dest, "N/A")}
              </p>
            </div>
            <div className="col-3">
              <p>
                <span className="fw-bold">Tipo de mercancía:</span>
                {safeValue(master?.resp?.master_merch, "N/A")}
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-3">
              <p>
                <span className="fw-bold">Piezas Master:</span>{" "}
                {safeValue(master?.resp?.master_pieces, "N/A")}
              </p>
            </div>
            <div className="col-3">
              <p>
                <span className="fw-bold">Peso Master:</span>{" "}
                {safeValue(master?.resp?.master_weight, "N/A")}
              </p>
            </div>
            <div className="col-3">
              <p>
                <span className="fw-bold">Volúmen Master:</span>{" "}
                {safeValue(master?.resp?.master_volume, "N/A")}
              </p>
            </div>
            {subproduct && (
              <div className="col-3">
                <p>
                  <span className="fw-bold">HBS:</span> {subproduct?.hbs}{" "}
                </p>
              </div>
            )}
          </div>

          {subproduct && (
            <div className="row">
              <div className="col-3">
                <p>
                  <span className="fw-bold">Piezas House:</span>{" "}
                  {safeValue(subproduct?.piezas, "N/A")}{" "}
                </p>
              </div>
              <div className="col-3">
                <p>
                  <span className="fw-bold">Peso House:</span>{" "}
                  {safeValue(subproduct?.peso, "N/A")}{" "}
                </p>
              </div>
              <div className="col-3">
                <p>
                  <span className="fw-bold">Volúmen House:</span>{" "}
                  {safeValue(subproduct?.peso, "N/A")}{" "}
                </p>
              </div>
            </div>
          )}

          <table className="table table-striped mt-3">
            <thead className="text-center">
              <tr>
                <th
                  style={{ backgroundColor: "#020C41", color: "white" }}
                  colSpan="6"
                >
                  Documentos a entregar
                </th>
              </tr>
              <tr className="text-center">
                <th></th>
                <th>No. Copias</th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody className="text-center">
              {/* Guía Master */}
              <tr>
                <td className="text-start">Guía Master</td>
                <td>4</td>
                <td>
                  Si{" "}
                  <input type="radio" {...register("master_awb")} value="1" />
                </td>
                <td>
                  No{" "}
                  <input type="radio" {...register("master_awb")} value="0" />
                </td>
                <td>
                  N/A{" "}
                  <input type="radio" {...register("master_awb")} value="2" />
                </td>
                <td>
                  ¿e-AWB? (Guía Electrónica){" "}
                  <input type="checkbox" {...register("master_eawb")} />
                </td>
              </tr>

              {subproduct && (
                <tr>
                  <td className="text-start">House Manifest</td>
                  <td>4</td>
                  <td>
                    Si{" "}
                    <input
                      type="radio"
                      {...register("house_manifest")}
                      value="1"
                    />
                  </td>
                  <td>
                    No{" "}
                    <input
                      type="radio"
                      {...register("house_manifest")}
                      value="0"
                    />
                  </td>
                  <td>
                    N/A{" "}
                    <input
                      type="radio"
                      {...register("house_manifest")}
                      value="2"
                    />
                  </td>
                  <td></td>
                </tr>
              )}

              {/* Pedimento Simplificado */}
              <tr>
                <td className="text-start">
                  Pedimento Simplificado con sello gama/DODA
                </td>
                <td>4</td>
                <td>
                  Si{" "}
                  <input
                    type="radio"
                    {...register("simplified_request")}
                    value="1"
                  />
                </td>
                <td>
                  No{" "}
                  <input
                    type="radio"
                    {...register("simplified_request")}
                    value="0"
                  />
                </td>
                <td>
                  N/A{" "}
                  <input
                    type="radio"
                    {...register("simplified_request")}
                    value="2"
                  />
                </td>
                <td></td>
              </tr>

              {/* Transferencia de carga */}
              <tr>
                <td className="text-start">Transferencia de carga</td>
                <td>2</td>
                <td>
                  Si{" "}
                  <input
                    type="radio"
                    {...register("cargo_transfer")}
                    value="1"
                  />
                </td>
                <td>
                  No{" "}
                  <input
                    type="radio"
                    {...register("cargo_transfer")}
                    value="0"
                  />
                </td>
                <td></td>
                <td></td>
              </tr>

              {/* Carta de seguridad */}
              <tr>
                <td className="text-start">Carta de seguridad</td>
                <td>2</td>
                <td>
                  Si{" "}
                  <input
                    type="radio"
                    {...register("security_letter")}
                    value="1"
                  />
                </td>
                <td>
                  No{" "}
                  <input
                    type="radio"
                    {...register("security_letter")}
                    value="0"
                  />
                </td>
                <td>
                  N/A{" "}
                  <input
                    type="radio"
                    {...register("security_letter")}
                    value="2"
                  />
                </td>
                <td></td>
              </tr>

              {/* Carta de aceptación */}
              <tr>
                <td className="text-start">Carta de aceptación</td>
                <td>2</td>
                <td>
                  Si{" "}
                  <input
                    type="radio"
                    {...register("acceptance_letter")}
                    value="1"
                  />
                </td>
                <td>
                  No{" "}
                  <input
                    type="radio"
                    {...register("acceptance_letter")}
                    value="0"
                  />
                </td>
                <td>
                  N/A{" "}
                  <input
                    type="radio"
                    {...register("acceptance_letter")}
                    value="2"
                  />
                </td>
                <td></td>
              </tr>

              {/* Copia gafete Aduanal */}
              <tr>
                <td className="text-start">Copia gafete Aduanal</td>
                <td>2</td>
                <td>
                  Si{" "}
                  <input type="radio" {...register("custom_badge")} value="1" />
                </td>
                <td>
                  No{" "}
                  <input type="radio" {...register("custom_badge")} value="0" />
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>

          {/* Tabla de Naturaleza y Manejo */}
          <table className="table table-striped mt-4">
            <colgroup>
              <col style={{ width: "10%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
            </colgroup>
            <thead className="text-center">
              <tr>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  NATURALEZA
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}></th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Piezas
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Peso
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  MANEJO
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  MANEJO
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Piezas
                </th>
                <th style={{ backgroundColor: "#020C41", color: "white" }}>
                  Peso
                </th>
              </tr>
            </thead>
            <tbody className="text-center">
              {/* Fila CGO (GENERAL) */}
              <tr className="text-start">
                <td className="text-end">CGO</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_cgo")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_cgo) === "1"
                    }
                  />{" "}
                  GENERAL
                </td>
                <td>
                  {watch("nat_cgo") && (
                    <input
                      type="number"
                      {...register("nat_cgo_pieces")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_cgo_pieces,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {watch("nat_cgo") && (
                    <input
                      type="number"
                      {...register("nat_cgo_weight")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_cgo_weight,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td className="text-end">ICE</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("han_ice")}
                    defaultChecked={
                      safeValue(master?.preve_save?.han_ice) === "1"
                    }
                  />{" "}
                  HIELO-SECO
                </td>
                <td>
                  {watch("han_ice") && (
                    <input
                      type="number"
                      {...register("han_ice_pieces")}
                      defaultValue={safeValue(
                        master?.preve_save?.han_ice_pieces,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {watch("han_ice") && (
                    <input
                      type="number"
                      {...register("han_ice_weight")}
                      defaultValue={safeValue(
                        master?.preve_save?.han_ice_weight,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
              </tr>

              {/* Fila DGR (PELIGROSA) */}
              <tr className="text-start">
                <td className="text-end">DGR</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_dgr")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_dgr) === "1"
                    }
                  />{" "}
                  PELIGROSA
                </td>
                <td>
                  {watch("nat_dgr") && (
                    <input
                      type="number"
                      {...register("nat_dgr_pieces")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_dgr_pieces,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {watch("nat_dgr") && (
                    <input
                      type="number"
                      {...register("nat_dgr_weight")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_dgr_weight,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td className="text-end">WET</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("han_wet")}
                    defaultChecked={
                      safeValue(master?.preve_save?.han_wet) === "1"
                    }
                  />{" "}
                  HÚMEDA
                </td>
                <td>
                  {watch("han_wet") && (
                    <input
                      type="number"
                      {...register("han_wet_pieces")}
                      defaultValue={safeValue(
                        master?.preve_save?.han_wet_pieces,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {watch("han_wet") && (
                    <input
                      type="number"
                      {...register("han_wet_weight")}
                      defaultValue={safeValue(
                        master?.preve_save?.han_wet_weight,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
              </tr>

              {/* Fila PER (PERECEDERO) */}
              <tr className="text-start">
                <td className="text-end">PER</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_per")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_per) === "1"
                    }
                  />{" "}
                  PERECEDERO
                </td>
                <td>
                  {watch("nat_per") && (
                    <input
                      type="number"
                      {...register("nat_per_pieces")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_per_pieces,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {watch("nat_per") && (
                    <input
                      type="number"
                      {...register("nat_per_weight")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_per_weight,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td className="text-end">BIG</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("han_big")}
                    defaultChecked={
                      safeValue(master?.preve_save?.han_big) === "1"
                    }
                  />{" "}
                  GRANDE
                </td>
                <td>
                  {watch("han_big") && (
                    <input
                      type="number"
                      {...register("han_big_pieces")}
                      defaultValue={safeValue(
                        master?.preve_save?.han_big_pieces,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {watch("han_big") && (
                    <input
                      type="number"
                      {...register("han_big_weight")}
                      defaultValue={safeValue(
                        master?.preve_save?.han_big_weight,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
              </tr>

              {/* Fila AVI (ANIMAL VIVO) */}
              <tr className="text-start">
                <td className="text-end">AVI</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_avi")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_avi) === "1"
                    }
                  />{" "}
                  ANIMAL VIVO
                </td>
                <td>
                  {watch("nat_avi") && (
                    <input
                      type="number"
                      {...register("nat_avi_pieces")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_avi_pieces,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {watch("nat_avi") && (
                    <input
                      type="number"
                      {...register("nat_avi_weight")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_avi_weight,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td className="text-end">HEA</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("han_hea")}
                    defaultChecked={
                      safeValue(master?.preve_save?.han_hea) === "1"
                    }
                  />{" "}
                  HEAVY
                </td>
                <td>
                  {watch("han_hea") && (
                    <input
                      type="number"
                      {...register("han_hea_pieces")}
                      defaultValue={safeValue(
                        master?.preve_save?.han_hea_pieces,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {watch("han_hea") && (
                    <input
                      type="number"
                      {...register("han_hea_weight")}
                      defaultValue={safeValue(
                        master?.preve_save?.han_hea_weight,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
              </tr>

              {/* Fila VAL (ALTO VALOR) */}
              <tr className="text-start">
                <td className="text-end">VAL</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_val")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_val) === "1"
                    }
                  />{" "}
                  ALTO VALOR
                </td>
                <td>
                  {watch("nat_val") && (
                    <input
                      type="number"
                      {...register("nat_val_pieces")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_val_pieces,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {watch("nat_val") && (
                    <input
                      type="number"
                      {...register("nat_val_weight")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_val_weight,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td className="text-end">HWC</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("han_hwc")}
                    defaultChecked={
                      safeValue(master?.preve_save?.han_hwc) === "1"
                    }
                  />{" "}
                  FRAGIL
                </td>
                <td>
                  {watch("han_hwc") && (
                    <input
                      type="number"
                      {...register("han_hwc_pieces")}
                      defaultValue={safeValue(
                        master?.preve_save?.han_hwc_pieces,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {watch("han_hwc") && (
                    <input
                      type="number"
                      {...register("han_hwc_weight")}
                      defaultValue={safeValue(
                        master?.preve_save?.han_hwc_weight,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
              </tr>

              {/* Fila HUM (RESTOS HUMANOS) */}
              <tr className="text-start">
                <td className="text-end">HUM</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_hum")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_hum) === "1"
                    }
                  />{" "}
                  RESTOS HUMANOS
                </td>
                <td>
                  {watch("nat_hum") && (
                    <input
                      type="number"
                      {...register("nat_hum_pieces")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_hum_pieces,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {watch("nat_hum") && (
                    <input
                      type="number"
                      {...register("nat_hum_weight")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_hum_weight,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td className="text-end">COL</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("han_col")}
                    defaultChecked={
                      safeValue(master?.preve_save?.han_col) === "1"
                    }
                  />{" "}
                  REFRI
                </td>
                <td>
                  {watch("han_col") && (
                    <input
                      type="number"
                      {...register("han_col_pieces")}
                      defaultValue={safeValue(
                        master?.preve_save?.han_col_pieces,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {watch("han_col") && (
                    <input
                      type="number"
                      {...register("han_col_weight")}
                      defaultValue={safeValue(
                        master?.preve_save?.han_col_weight,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
              </tr>

              {/* Fila DIP (VALIJA DIPLOMATICA) */}
              <tr className="text-start">
                <td className="text-end">DIP</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_dip")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_dip) === "1"
                    }
                  />{" "}
                  VALIJA DIPLOMATICA
                </td>
                <td>
                  {watch("nat_dip") && (
                    <input
                      type="number"
                      {...register("nat_dip_pieces")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_dip_pieces,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {watch("nat_dip") && (
                    <input
                      type="number"
                      {...register("nat_dip_weight")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_dip_weight,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td className="text-end">FRO</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("han_fro")}
                    defaultChecked={
                      safeValue(master?.preve_save?.han_fro) === "1"
                    }
                  />{" "}
                  CONGELADOR
                </td>
                <td>
                  {watch("han_fro") && (
                    <input
                      type="number"
                      {...register("han_fro_pieces")}
                      defaultValue={safeValue(
                        master?.preve_save?.han_fro_pieces,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {watch("han_fro") && (
                    <input
                      type="number"
                      {...register("han_fro_weight")}
                      defaultValue={safeValue(
                        master?.preve_save?.han_fro_weight,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
              </tr>

              {/* Fila NWP (PRENSA) */}
              <tr className="text-start">
                <td className="text-end">NWP</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_nwp")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_nwp) === "1"
                    }
                  />{" "}
                  PRENSA
                </td>
                <td>
                  {watch("nat_nwp") && (
                    <input
                      type="number"
                      {...register("nat_nwp_pieces")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_nwp_pieces,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {watch("nat_nwp") && (
                    <input
                      type="number"
                      {...register("nat_nwp_weight")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_nwp_weight,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td className="text-end">N/A</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("han_na")}
                    defaultChecked={
                      safeValue(master?.preve_save?.han_na) === "1"
                    }
                  />{" "}
                  NO APLICA
                </td>
                <td>
                  {watch("han_na") && (
                    <input
                      type="number"
                      {...register("han_na_pieces")}
                      defaultValue={safeValue(
                        master?.preve_save?.han_na_pieces,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {watch("han_na") && (
                    <input
                      type="number"
                      {...register("han_na_weight")}
                      defaultValue={safeValue(
                        master?.preve_save?.han_na_weight,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
              </tr>

              {/* Fila MAL (MAIL) */}
              <tr className="text-start">
                <td className="text-end">MAL</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_mal")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_mal) === "1"
                    }
                  />{" "}
                  MAIL
                </td>
                <td>
                  {watch("nat_mal") && (
                    <input
                      type="number"
                      {...register("nat_mal_pieces")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_mal_pieces,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {watch("nat_mal") && (
                    <input
                      type="number"
                      {...register("nat_mal_weight")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_mal_weight,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>

              {/* Fila COM (COMAT AM) */}
              <tr className="text-start">
                <td className="text-end">COM</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_com")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_com) === "1"
                    }
                  />{" "}
                  COMAT AM
                </td>
                <td>
                  {watch("nat_com") && (
                    <input
                      type="number"
                      {...register("nat_com_pieces")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_com_pieces,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {watch("nat_com") && (
                    <input
                      type="number"
                      {...register("nat_com_weight")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_com_weight,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>

              {/* Fila VIC (VALOR DECLARADO) */}
              <tr className="text-start">
                <td className="text-end">VIC</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_vic")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_vic) === "1"
                    }
                  />{" "}
                  VALOR DECLARADO
                </td>
                <td>
                  {watch("nat_vic") && (
                    <input
                      type="number"
                      {...register("nat_vic_pieces")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_vic_pieces,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {watch("nat_vic") && (
                    <input
                      type="number"
                      {...register("nat_vic_weight")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_vic_weight,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>

              {/* Fila PIL (PHARMA) */}
              <tr className="text-start">
                <td className="text-end">PIL</td>
                <td>
                  <input
                    type="checkbox"
                    {...register("nat_pil")}
                    defaultChecked={
                      safeValue(master?.preve_save?.nat_pil) === "1"
                    }
                  />{" "}
                  PHARMA
                </td>
                <td>
                  {watch("nat_pil") && (
                    <input
                      type="number"
                      {...register("nat_pil_pieces")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_pil_pieces,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td>
                  {watch("nat_pil") && (
                    <input
                      type="number"
                      {...register("nat_pil_weight")}
                      defaultValue={safeValue(
                        master?.preve_save?.nat_pil_weight,
                        ""
                      )}
                      className="form-control form-control-sm"
                    />
                  )}
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>

          <div className="row">
            <div className="col-5">
              <p>
                <span className="fw-bold">DESTINO ACAS:</span>&nbsp;{" "}
                {master?.acas_iatas ? "SI" : "NO"}
              </p>
            </div>
            <div className="col-6">
              <div
                style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
              >
                <span className="fw-bold">*Temperatura requerida:</span>
                <select
                  className="form-select"
                  name="required_temp"
                  style={{ width: "auto" }}
                  {...register("required_temp")}
                  defaultValue={safeValue(
                    master?.preve_save?.required_temp,
                    "N/A"
                  )}
                >
                  {master?.temperatures && master?.temperatures.length > 0 ? (
                    master?.temperatures.map((temperature) => (
                      <option
                        key={temperature.id}
                        value={safeValue(temperature.name, "N/A")}
                      >
                        {safeValue(temperature.name, "N/A")}
                      </option>
                    ))
                  ) : (
                    <option value="N/A">N/A</option>
                  )}
                </select>
              </div>
            </div>
          </div>

          {safeValue(master?.merchandise_type?.name) === "Cont activos" && (
            <div className="row align-items-center mb-3">
              {/* Contenedores activos */}
              <div className="col-4 d-flex flex-column gap-3">
                <p
                  className="sub-title fw-bold mt-4"
                  style={{ color: "#020C41" }}
                >
                  Contenedores activos
                </p>

                {/* RKN */}
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="checkbox"
                    {...register("contActivos_RKN")}
                    defaultChecked={isChecked(
                      master?.preve_save?.contActivos_RKN
                    )}
                    onChange={(e) => {
                      if (!e.target.checked) {
                        setValue("contActivos_RKN_number", "");
                      }
                    }}
                  />
                  <span>RKN</span>
                  <input
                    type="number"
                    className="form-control form-control-sm w-50"
                    {...register("contActivos_RKN_number")}
                    disabled={!watch("contActivos_RKN")}
                    defaultValue={safeValue(
                      master?.preve_save?.contActivos_RKN_number,
                      ""
                    )}
                  />
                </div>

                {/* RAP */}
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="checkbox"
                    {...register("contActivos_RAP")}
                    defaultChecked={isChecked(
                      master?.preve_save?.contActivos_RAP
                    )}
                    onChange={(e) => {
                      if (!e.target.checked) {
                        setValue("contActivos_RAP_number", "");
                      }
                    }}
                  />
                  <span>RAP</span>
                  <input
                    type="number"
                    className="form-control form-control-sm w-50"
                    {...register("contActivos_RAP_number")}
                    disabled={!watch("contActivos_RAP")}
                    defaultValue={safeValue(
                      master?.preve_save?.contActivos_RAP_number,
                      ""
                    )}
                  />
                </div>
              </div>

              {/* Preparación de contenedor */}
              <div className="col-4 d-flex flex-column gap-3">
                <p
                  className="sub-title fw-bold mt-4"
                  style={{ color: "#020C41" }}
                >
                  Preparación de contenedor
                </p>

                {/* RKN */}
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="checkbox"
                    {...register("prepContenedor_RKN")}
                    defaultChecked={isChecked(
                      master?.preve_save?.prepContenedor_RKN
                    )}
                    onChange={(e) => {
                      if (!e.target.checked) {
                        setValue("prepContenedor_RKN_number", "");
                      }
                    }}
                  />
                  <span>RKN</span>
                  <input
                    type="number"
                    className="form-control form-control-sm w-50"
                    {...register("prepContenedor_RKN_number")}
                    disabled={!watch("prepContenedor_RKN")}
                    defaultValue={safeValue(
                      master?.preve_save?.prepContenedor_RKN_number,
                      ""
                    )}
                  />
                </div>

                {/* RAP */}
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="checkbox"
                    {...register("prepContenedor_RAP")}
                    defaultChecked={isChecked(
                      master?.preve_save?.prepContenedor_RAP
                    )}
                    onChange={(e) => {
                      if (!e.target.checked) {
                        setValue("prepContenedor_RAP_number", "");
                      }
                    }}
                  />
                  <span>RAP</span>
                  <input
                    type="number"
                    className="form-control form-control-sm w-50"
                    {...register("prepContenedor_RAP_number")}
                    disabled={!watch("prepContenedor_RAP")}
                    defaultValue={safeValue(
                      master?.preve_save?.prepContenedor_RAP_number,
                      ""
                    )}
                  />
                </div>
              </div>
            </div>
          )}

          {watch("han_col") &&
            master?.booking_flights &&
            master?.booking_flights.length > 0 && (
              <>
                <p
                  className="sub-title fw-bold mt-4"
                  style={{ color: "#020C41" }}
                >
                  Vuelos Reservados Refri
                </p>
                <table className="table mt-3">
                  <thead className="text-center">
                    <tr>
                      <th
                        style={{ backgroundColor: "#020C41", color: "white" }}
                      >
                        Vuelo
                      </th>
                      <th
                        style={{ backgroundColor: "#020C41", color: "white" }}
                      >
                        Año
                      </th>
                      <th
                        style={{ backgroundColor: "#020C41", color: "white" }}
                      >
                        Hora
                      </th>
                      <th
                        style={{ backgroundColor: "#020C41", color: "white" }}
                      >
                        Piezas
                      </th>
                      <th
                        style={{ backgroundColor: "#020C41", color: "white" }}
                      >
                        Peso
                      </th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {master?.booking_flights.map((flight, index) => (
                      <tr key={index}>
                        <td>{safeValue(flight.flight, "N/A")}</td>
                        <td>{safeValue(flight.year, "N/A")}</td>
                        <td>{safeValue(flight.time, "N/A")}</td>
                        <td>
                          <input
                            type="number"
                            {...register(`flights_col_pieces_${index}`)}
                            defaultValue={safeValue(flight.col_pieces, "")}
                            className="form-control form-control-sm"
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            {...register(`flights_col_weight_${index}`)}
                            defaultValue={safeValue(flight.col_weight, "")}
                            className="form-control form-control-sm"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}

          {watch("han_fro") &&
            master?.booking_flights &&
            master?.booking_flights.length > 0 && (
              <>
                <p
                  className="sub-title fw-bold mt-4"
                  style={{ color: "#020C41" }}
                >
                  Vuelos Reservados Conge
                </p>
                <table className="table mt-3">
                  <thead className="text-center">
                    <tr>
                      <th
                        style={{ backgroundColor: "#020C41", color: "white" }}
                      >
                        Vuelo
                      </th>
                      <th
                        style={{ backgroundColor: "#020C41", color: "white" }}
                      >
                        Año
                      </th>
                      <th
                        style={{ backgroundColor: "#020C41", color: "white" }}
                      >
                        Hora
                      </th>
                      <th
                        style={{ backgroundColor: "#020C41", color: "white" }}
                      >
                        Piezas
                      </th>
                      <th
                        style={{ backgroundColor: "#020C41", color: "white" }}
                      >
                        Peso
                      </th>
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {master?.booking_flights.map((flight, index) => (
                      <tr key={index}>
                        <td>{safeValue(flight.flight, "N/A")}</td>
                        <td>{safeValue(flight.year, "N/A")}</td>
                        <td>{safeValue(flight.time, "N/A")}</td>
                        <td>
                          <input
                            type="number"
                            {...register(`flights_fro_pieces_${index}`)}
                            defaultValue={safeValue(flight.fro_pieces, "")}
                            className="form-control form-control-sm"
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            {...register(`flights_fro_weight_${index}`)}
                            defaultValue={safeValue(flight.fro_weight, "")}
                            className="form-control form-control-sm"
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}

          {watch("nat_dgr") && (
            <>
              <p className="amc-text fw-bold mt-4" style={{ color: "#020C41" }}>
                ¿Contiene DG exentas de verificación?
              </p>
              SÍ{" "}
              <input
                type="radio"
                style={{ marginRight: "14rem" }}
                {...register("has_dg_exempt")}
                value="si"
                defaultChecked={
                  safeValue(master?.preve_save?.has_dg_exempt) === "si"
                }
              />
              NO{" "}
              <input
                type="radio"
                {...register("has_dg_exempt")}
                value="no"
                defaultChecked={
                  safeValue(master?.preve_save?.has_dg_exempt) === "no"
                }
              />
              {watch("has_dg_exempt") === "no" && (
                <div style={{ marginTop: "1rem" }}>
                  <p
                    className="amc-text fw-bold mt-4"
                    style={{ color: "#020C41" }}
                  >
                    UN (MERCANCÍAS PELIGROSAS)
                  </p>
                  <input
                    type="text"
                    {...register("un_dg")}
                    defaultValue={safeValue(master?.preve_save?.un_dg, "")}
                    className="form-control mb-2"
                    style={{ width: "20%" }}
                  />
                  <p className="amc-notes" style={{ color: "#DC3545" }}>
                    Agregar cantidad total de UN en la guía
                  </p>
                </div>
              )}
            </>
          )}

          <div className="row">
            <div className="col">
              <p
                className="sub-title fw-bold mt-4"
                style={{ color: "#020C41" }}
              >
                Entregas adicionales
              </p>

              {/* CARGAS ESPECIALES */}
              <p>
                <input
                  type="checkbox"
                  {...register("specialLoads")}
                  defaultChecked={hasValue(master?.preve_save?.special_cargo)}
                />{" "}
                CARGAS ESPECIALES
              </p>
              {watch("specialLoads") && (
                <div>
                  <table
                    className="table table-striped table-bordered mb-4"
                    style={{ width: "70%", margin: "0 auto" }}
                  >
                    <tbody className="text-center">
                      <tr>
                        <td className="text-start">Cuaderno ATA, Oficio SAT</td>
                        <td>1</td>
                        <td>
                          Si{" "}
                          <input
                            type="radio"
                            value="1"
                            checked={watch("ata_sat_office") === "1"}
                            onChange={() => setValue("ata_sat_office", "1")}
                          />
                        </td>
                        <td>
                          No{" "}
                          <input
                            type="radio"
                            value="0"
                            checked={watch("ata_sat_office") === "0"}
                            onChange={() => setValue("ata_sat_office", "0")}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}

              {/* CARGAS INTERLINEALES */}
              <p>
                <input
                  type="checkbox"
                  {...register("interlineLoads")}
                  defaultChecked={hasValue(
                    master?.preve_save?.interlineal_cargo
                  )}
                />{" "}
                CARGAS INTERLINEALES
              </p>
              {watch("interlineLoads") && (
                <div>
                  <table
                    className="table table-striped table-bordered mb-4"
                    style={{ width: "70%", margin: "0 auto" }}
                  >
                    <tbody className="text-center">
                      <tr>
                        <td className="text-start">Transferencia</td>
                        <td>1</td>
                        <td>
                          Si{" "}
                          <input
                            type="radio"
                            {...register("intcar_transfer")}
                            value="1"
                            defaultChecked={
                              safeValue(master?.preve_save?.intcar_transfer) ===
                              "1"
                            }
                          />
                        </td>
                        <td>
                          No{" "}
                          <input
                            type="radio"
                            {...register("intcar_transfer")}
                            value="0"
                            defaultChecked={
                              safeValue(master?.preve_save?.intcar_transfer) ===
                              "0"
                            }
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}

              {/* PERECEDEROS */}
              <p>
                <input
                  type="checkbox"
                  {...register("nat_per_disabled")}
                  checked={watch("nat_per")}
                  disabled
                />{" "}
                PERECEDEROS
              </p>
              {watch("nat_per") && (
                <div>
                  <table
                    className="table table-striped table-bordered mb-4"
                    style={{ width: "70%", margin: "0 auto" }}
                  >
                    <tbody className="text-center">
                      <tr>
                        <td className="text-start">
                          Certificado fitosanitario o Certificado de negativa
                          del certificado
                        </td>
                        <td>1</td>
                        <td>
                          Si{" "}
                          <input
                            type="radio"
                            {...register("perishables_certified")}
                            value="1"
                            defaultChecked={
                              safeValue(
                                master?.preve_save?.perishables_certified
                              ) === "1"
                            }
                          />
                        </td>
                        <td>
                          No{" "}
                          <input
                            type="radio"
                            {...register("perishables_certified")}
                            value="0"
                            defaultChecked={
                              safeValue(
                                master?.preve_save?.perishables_certified
                              ) === "0"
                            }
                          />
                        </td>
                        <td>
                          N/A{" "}
                          <input
                            type="radio"
                            {...register("perishables_certified")}
                            value="2"
                            defaultChecked={
                              safeValue(
                                master?.preve_save?.perishables_certified
                              ) === "2"
                            }
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}

              {/* MERCANCÍAS PELIGROSAS */}
              <p>
                <input
                  type="checkbox"
                  {...register("nat_dgr_disabled")}
                  checked={watch("nat_dgr")}
                  disabled
                />{" "}
                MERCANCÍAS PELIGROSAS
              </p>
              {watch("nat_dgr") && (
                <div>
                  <table
                    className="table table-striped table-bordered mb-4"
                    style={{ width: "70%", margin: "0 auto" }}
                  >
                    <tbody className="text-center">
                      <tr>
                        <td className="text-start">DGD</td>
                        <td>2</td>
                        <td>
                          Si{" "}
                          <input
                            type="radio"
                            {...register("dg")}
                            value="1"
                            defaultChecked={
                              safeValue(master?.preve_save?.dg) === "1"
                            }
                          />
                        </td>
                        <td>
                          No{" "}
                          <input
                            type="radio"
                            {...register("dg")}
                            value="0"
                            defaultChecked={
                              safeValue(master?.preve_save?.dg) === "0"
                            }
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}

              {/* ANIMALES VIVOS */}
              <p>
                <input
                  type="checkbox"
                  {...register("nat_avi_disabled")}
                  checked={watch("nat_avi")}
                  disabled
                />{" "}
                ANIMALES VIVOS
              </p>
              {watch("nat_avi") && (
                <div>
                  <table
                    className="table table-striped table-bordered mb-4"
                    style={{ width: "70%", margin: "0 auto" }}
                  >
                    <tbody className="text-center">
                      <tr>
                        <td className="text-start">
                          Certificado del embarcador (no IATA)
                        </td>
                        <td>1</td>
                        <td>
                          Si{" "}
                          <input
                            type="radio"
                            {...register("shipper_certified")}
                            value="1"
                            defaultChecked={
                              safeValue(
                                master?.preve_save?.shipper_certified
                              ) === "1"
                            }
                          />
                        </td>
                        <td>
                          No{" "}
                          <input
                            type="radio"
                            {...register("shipper_certified")}
                            value="0"
                            defaultChecked={
                              safeValue(
                                master?.preve_save?.shipper_certified
                              ) === "0"
                            }
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}

              {/* RESTOS HUMANOS */}
              <p>
                <input
                  type="checkbox"
                  {...register("nat_hum_disabled")}
                  checked={watch("nat_hum")}
                  disabled
                />{" "}
                RESTOS HUMANOS
              </p>
              {watch("nat_hum") && (
                <div>
                  <table
                    className="table table-striped table-bordered mb-4"
                    style={{ width: "70%", margin: "0 auto" }}
                  >
                    <thead className="text-center">
                      <tr>
                        <th></th>
                        <th></th>
                        <th>* Incluye apostillado</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody className="text-center">
                      <tr>
                        <td className="text-start">
                          Certificado de Defunción*
                        </td>
                        <td>1</td>
                        <td>
                          Si{" "}
                          <input
                            type="radio"
                            {...register("hr_cert")}
                            value="1"
                            defaultChecked={
                              safeValue(master?.preve_save?.hr_cert) === "1"
                            }
                          />
                        </td>
                        <td>
                          No{" "}
                          <input
                            type="radio"
                            {...register("hr_cert")}
                            value="0"
                            defaultChecked={
                              safeValue(master?.preve_save?.hr_cert) === "0"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="text-start">Permiso de Traslado*</td>
                        <td>1</td>
                        <td>
                          Si{" "}
                          <input
                            type="radio"
                            {...register("hr_permission_transfer")}
                            value="1"
                            defaultChecked={
                              safeValue(
                                master?.preve_save?.hr_permission_transfer
                              ) === "1"
                            }
                          />
                        </td>
                        <td>
                          No{" "}
                          <input
                            type="radio"
                            {...register("hr_permission_transfer")}
                            value="0"
                            defaultChecked={
                              safeValue(
                                master?.preve_save?.hr_permission_transfer
                              ) === "0"
                            }
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="text-start">
                          Permiso de Embalsamamiento*
                        </td>
                        <td>1</td>
                        <td>
                          Si{" "}
                          <input
                            type="radio"
                            {...register("hr_permission")}
                            value="1"
                            defaultChecked={
                              safeValue(master?.preve_save?.hr_permission) ===
                              "1"
                            }
                          />
                        </td>
                        <td>
                          No{" "}
                          <input
                            type="radio"
                            {...register("hr_permission")}
                            value="0"
                            defaultChecked={
                              safeValue(master?.preve_save?.hr_permission) ===
                              "0"
                            }
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col mt-4 d-flex justify-content-end gap-3">
              <button className="btnn" type="button" onClick={handleTicket}>
                Ticket
              </button>
              <button className="btnn" type="submit" disabled={isSubmitting}>
                {isSubmitting ? "Guardando..." : "Guardar"}
              </button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default ReceptionForm;
